module.exports = __webpack_public_path__ + "static/media/keys.2e55faf4.svg";